document.addEventListener('DOMContentLoaded', function () {

    if (typeof wp !== 'undefined' && wp.domReady) {
        wp.domReady(function () {
            setTimeout(function () {
                faq()
            }, 800); // Delay after the DOM is ready
        });
    } else {
        faq()
    }

    function faq() {

        const headers = document.querySelectorAll(".faq .accordion-header");

        headers.forEach(header => {
            header.addEventListener("click", () => {
                const currentlyOpen = document.querySelector(".faq .accordion-body.open");

                // Close the currently open item
                if (currentlyOpen && currentlyOpen !== header.nextElementSibling) {
                    currentlyOpen.style.maxHeight = null;
                    currentlyOpen.classList.remove("open");
                    currentlyOpen.previousElementSibling.querySelector(".icon").classList.remove("open");
                    currentlyOpen.previousElementSibling.querySelector(".icon").classList.add("closed");
                }

                const body = header.nextElementSibling;
                const icon = header.querySelector(".icon");

                if (body.classList.contains("open")) {
                    body.style.maxHeight = null;
                    body.classList.remove("open");
                    icon.classList.remove("open");
                    icon.classList.add("closed");
                } else {
                    body.style.maxHeight = body.scrollHeight + "px";
                    body.classList.add("open");
                    icon.classList.remove("closed");
                    icon.classList.add("open");
                }
            });
        });
    }
});

